import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContentHeader from "../components/ContentHeader";
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used

const CloudProviders = () => {
    const title = "Cloud Providers"
    return (
		<Fragment>
                <ContentHeader
					title={title}
				/>

                <div className="text-left flex-1 pt-10 ml-24 border-b border-solid border-border">
                    <ul className="text-left flex flex-col lg:flex-row lg:space-x-16 font-semibold text-lg">
                        <li className="border-primary">
							<div className="border-solid border-bottom border-primary border-b-2 h-12">
                                <a href="/#" className="block py-2 pr-4 pl-3 cursor-pointer text-primary hover:text-primary lg:hover:bg-transparent lg:border-0 lg:p-0">
									<FontAwesomeIcon icon={icon({name: 'house', family: 'sharp', style: 'solid'})} className="pr-2 text-sm"/>
									Overview
								</a>
                            </div>
                        </li>
                        <li>
                            <div>
                                <a href="/#" className="block py-2 pr-4 pl-3 cursor-pointer text-text-2 hover:text-primary lg:hover:bg-transparent lg:border-0 lg:p-0">
									<FontAwesomeIcon icon={icon({name: 'computer', family: 'sharp', style: 'solid'})} className="pr-2 text-sm"/>
									IT Components
								</a>
                            </div>
                        </li>
                        <li>
                            <div>
                                <a href="/#" className="block py-2 pr-4 pl-3 cursor-pointer text-text-2 hover:text-primary lg:hover:bg-transparent lg:border-0 lg:p-0">
									<FontAwesomeIcon icon={icon({name: 'sitemap', family: 'sharp', style: 'solid'})} className="pr-2 text-sm"/>
									Organizations
								</a>
                            </div>
                        </li>
                        <li>
                            <div>
                                <a href="/#" className="block py-2 pr-4 pl-3 cursor-pointer text-text-2 hover:text-primary lg:hover:bg-transparent lg:border-0 lg:p-0">
									<FontAwesomeIcon icon={icon({name: 'box-archive', family: 'sharp', style: 'solid'})} className="pr-2 text-sm"/>
									Products
								</a>
                            </div>
                        </li>
                    </ul>
                </div>

		</Fragment>
	);
};

export default CloudProviders;